(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .service('DocumentDownloadPdf', DocumentDownloadPdf);

    DocumentDownloadPdf.$inject = ['$uibModal', '$translate', 'DocumentFile', 'Document', 'DataUtils', 'Notification'];

    function DocumentDownloadPdf($uibModal, $translate, DocumentFile, Document, DataUtils, Notification) {
        this.download = function($event, document, fileId, fileType) {
            $event.preventDefault();
            Document.downloadNeedApproval({ id: document.id }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;
                if ((isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE')) && !document.approved && downloadNeedApproval === 'true') {
                    $uibModal.open({
                        templateUrl: 'app/entities/document/document-approval-dialog.html',
                        controller: 'DocumentApprovalController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Document', function(Document) {
                                return Document.get({ id: document.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        Document.get({ id: document.id }).$promise.then(function(r) {
                            document.approved = r.approved;
                            document.approvedBy = r.approvedBy;
                            document.approvedDate = r.approvedDate;
                            DocumentFile.download({ id: fileId }).$promise.then(function(result) {
                                DataUtils.viewServerFile(result);
                                Document.addDownload({
                                    documentId: document.id,
                                    fileId: fileId,
                                    fileType: fileType
                                });
                                Document.addView(document.id);
                            }, function(err) {
                                processDownloadError(err);
                            });
                        }, function() {
                            Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
                        });
                    });
                } else {
                    DocumentFile.download({ id: fileId }).$promise.then(function(result) {
                        Document.addDownload({
                            documentId: document.id,
                            fileId: fileId,
                            fileType: fileType
                        });
                        Document.addView(document.id);
                        DataUtils.viewServerFile(result);
                    }, function(err) {
                        processDownloadError(err);
                    });
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        // EDOCS-378: a file is served only with the link that shows it (document.hashedId is that link's hash)
        this.downloadExternal = function($event, document, fileHashedId) {
            $event.preventDefault();
            Document.downloadNeedApprovalExternal({ hash: document.hashedId }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;
                if ((isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE')) && !document.approved && downloadNeedApproval === 'true') {
                    // No sign-in step. The recipient holds a link addressed to them; requiring an
                    // account on top of that is not something Art. 78.o n.o 5 of the CIVA asks for,
                    // and it is what stopped customers' customers acknowledging their credit notes.
                    approveExternalThen(document, function() {
                        DocumentFile.externalDownload({ hash: fileHashedId, access: document.hashedId }).$promise.then(function(result) {
                            DataUtils.viewServerFile(result);
                            DocumentFile.addExternalDownload(fileHashedId);
                        }, function(err) {
                            processDownloadError(err);
                        });
                    });
                } else {
                    DocumentFile.externalDownload({ hash: fileHashedId, access: document.hashedId }).$promise.then(function(result) {
                        DataUtils.viewServerFile(result);
                        DocumentFile.addExternalDownload(fileHashedId);
                    }, function(err) {
                        processDownloadError(err);
                    });
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        /**
         * Opens the approval dialog for one document and runs `onApproved` once it has been
         * approved. Shared by the single-document and bundle paths so both collect the
         * acknowledgement the same way.
         */
        function approveExternalThen(document, onApproved) {
            $uibModal.open({
                templateUrl: 'app/entities/document/document-approval-by-hashid-dialog.html',
                controller: 'DocumentApprovalByHashIdController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Document', function(Document) {
                        return Document.getByExternalHash({ hash: document.hashedId }).$promise;
                    }]
                }
            }).result.then(function() {
                Document.getByExternalHash({ hash: document.hashedId }).$promise.then(function(r) {
                    document.approved = r.approved;
                    document.approvedBy = r.approvedBy;
                    document.approvedDate = r.approvedDate;
                    onApproved();
                }, function() {
                    Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
                });
            }, angular.noop);
        }

        function processDownloadError(error) {
            if (error.status === 404) {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
            } else {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.errorDownloading') + ': ' + $translate.instant('error.' + DataUtils.getErrorMessageFromArrayBuffer(error.data.data)) });
            }
        }

        this.downloadAllFilesExternal = function($event, documentExternalAccessHash, documents) {
            $event.preventDefault();
            Document.downloadAllNeedApprovalExternal({ hash: documentExternalAccessHash }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;

                if (downloadNeedApproval === 'true' && !areAllDocumentsApproved(documents)) {
                    // This used to show "todos os documentos tem de estar aprovados" and stop,
                    // with no way to approve them from here. The primary call to action on the
                    // bundle page was a dead end.
                    //
                    // One dialog per document rather than one for the lot: the acknowledgement
                    // Art. 78.o n.o 5 requires is per document, and each statement names its own
                    // number, value and date.
                    approveEachThen(pendingApprovals(documents), function() {
                        downloadBundle(documentExternalAccessHash);
                    });
                } else {
                    downloadBundle(documentExternalAccessHash);
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        function pendingApprovals(documents) {
            var list = angular.isArray(documents) ? documents : [documents];
            return list.filter(function(document) {
                return (isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE'))
                    && !document.approved;
            });
        }

        /**
         * Walks the pending documents one dialog at a time, then runs `onAllApproved`. Dismissing
         * any dialog stops the chain and runs nothing — the recipient changed their mind, and a
         * bundle must not be served with one of its credit notes unacknowledged.
         */
        function approveEachThen(pending, onAllApproved) {
            if (!pending.length) {
                onAllApproved();
                return;
            }
            approveExternalThen(pending[0], function() {
                approveEachThen(pending.slice(1), onAllApproved);
            });
        }

        function downloadBundle(documentExternalAccessHash) {
            Document.downloadAllExternalAsZip({
                hash: documentExternalAccessHash
            }, function(result) {
                if (result.filename !== null) {
                    Document.addAllExternalDownloads(documentExternalAccessHash);
                    DataUtils.viewServerFile(result);
                } else {
                    Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
                }
            }, function() {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
            });
        }

        /**
         * Checks whether one of the documents (or document, if passed object is not an array) is of passed document type
         *
         * @param documents
         * @param documentType
         * @returns {boolean|*}
         */
        function isAnyDocumentOfType(documents, documentType) {
            if (documents.documentType === documentType) {
                return true;
            }
            for (var i = 0; i < documents.length; i++) {
                if (documents[i].documentType === documentType) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Checks whether all documents (or document, if passed object is not an array) are (is) approved but only if from specific type
         *
         * @param documents
         * @returns {boolean|*}
         */
        function areAllDocumentsApproved(documents) {
            if (documents.documentNumber) {
                if (isAnyDocumentOfType(documents, 'SELFBILLED') || isAnyDocumentOfType(documents, 'CREDITNOTE')) {
                    return documents.approved;
                }
                return true;
            }
            for (var i = 0; i < documents.length; i++) {
                if ((isAnyDocumentOfType(documents[i], 'SELFBILLED') || isAnyDocumentOfType(documents[i], 'CREDITNOTE')) && !documents[i].approved) {
                    return false;
                }
            }
            return true;
        }
    }
})();
